import Http from '../utils/http'
import store from 'store/index'

export const accountActivate = (payload) => Http.post('/accounts/activate', payload)

export const update = (payload) => Http.put(`/company`, payload)
       .then(response => {
           store.dispatch('saveCompany', response.data)
           return response.data
       })

export const updateLogo = (payload) => Http.post(`/company/logo`, payload)
       .then(response => {
           store.dispatch('saveCompany', response.data)
           return response.data
       })

export const updateWebhook = (payload) => Http.post(`/company/webhook`, payload)
        .then(response => {
            store.dispatch('saveCompany', response.data)
            return response.data
        })

export const refreshMembers = (payload) => Http.get(`/company/members`, payload)
       .then(response => {
           store.dispatch('setMembers', response.data)
           return response.data
       })



// WEBPACK FOOTER //
// ./src/services/company.js